import script from "./QGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./QGroup.vue?vue&type=script&setup=true&lang=ts"

import "./QGroup.vue?vue&type=style&index=0&id=1fa7ba86&lang=scss&scoped=true"
script.__scopeId = "data-v-1fa7ba86"

export default script